import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatDateRangePicker = createCustomElementWrapper('kat-date-range-picker', 'KatDateRangePicker', {
    'endLabel': 'end-label',
    'endName': 'end-name',
    'endValue': 'end-value',
    'startLabel': 'start-label',
    'startName': 'start-name',
    'startValue': 'start-value',
}, {
    'onChange': 'change',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/date-range-picker.js
// module id = 1210
// module chunks = 0